// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconSuccess::before {
  background-color: #48df0a !important;
}

@media only screen and (max-width: 760px) {
  .successModalHeader h2 {
    font-size: 1rem !important;
  }
}
.note-button-div {
  position: fixed;
  z-index: 50;
  right: 0px;
  top: 300px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.note-button {
  background-color: #274bdb;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-recruitment-step-form/agent-recruitment-step-form.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AACA;EACE;IACE,0BAAA;EAEF;AACF;AAAA;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,4EAAA;AAEF;;AAAA;EACE,yBAAA;EACA,WAAA;AAGF","sourcesContent":[".iconSuccess::before {\r\n  background-color: #48df0a !important;\r\n}\r\n@media only screen and (max-width: 760px) {\r\n  .successModalHeader h2 {\r\n    font-size: 1rem !important;\r\n  }\r\n}\r\n.note-button-div {\r\n  position: fixed;\r\n  z-index: 50;\r\n  right: 0px;\r\n  top: 300px;\r\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n.note-button {\r\n  background-color: #274bdb;\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
